import { render, staticRenderFns } from "./FieldMetricsWrapper.vue?vue&type=template&id=1dcdef45"
import script from "./FieldMetricsWrapper.vue?vue&type=script&lang=js"
export * from "./FieldMetricsWrapper.vue?vue&type=script&lang=js"
import style0 from "./FieldMetricsWrapper.vue?vue&type=style&index=0&id=1dcdef45&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports